import selectStyles from './selectStyles';
const selectFilterStyles = (field) => {
    return {
        ...selectStyles(),
        control: (provided, state) => {
            let outline = provided.outline;
            let boxShadow = provided.boxShadow;
            let borderColor = provided.borderColor;
            let backgroundColor = provided.backgroundColor;

            if (!state.isDisabled) {
                if (state.menuIsOpen || state.isFocused) {
                    outline = 0;
                    borderColor = `#80bdff`;
                    boxShadow = `0 0 0 .2rem rgba(0,123,255,.25)`
                }

                if (!field.valid) {
                    borderColor = `#dc3545`;
                    if (state.menuIsOpen || state.isFocused) {
                        boxShadow = `0 0 0 .2rem rgba(220,53,69,.25)`
                    }
                }
            } else {
                backgroundColor = `#f8f9fa`;
                borderColor = `#ced4da`;
            }

            const newStyles = {
                ...outline,
                boxShadow,
                borderColor,
                backgroundColor,
                transition: `none`,
                borderRadius: `20px`,
                ...(
                    state.menuIsOpen ? {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    } : {})
            }
            return {
                ...provided,
                ...newStyles,
                ':hover': {
                    ...provided[':hover'],
                    ...newStyles
                }
            }
        },
    }
}

export default selectFilterStyles;
